import { PropTypes } from 'prop-types';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const ProfilerDummy = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
ProfilerDummy.propTypes = {
  children: PropTypes.element.isRequired
};
export { ProfilerDummy };
//# sourceMappingURL=ProfilerDummy.js.map